// Admin API - barrel re-export combining all admin sub-modules
import { adminUsersApi } from "./users";
import { adminProsApi } from "./pros";
import { adminProjectsApi } from "./projects";
import { adminTaxonomyApi } from "./taxonomy";
import { adminBlogsApi } from "./blogs";
import { adminAnalyticsApi } from "./analytics";
import { adminCommunicationsApi } from "./communications";
import { adminFeedbackApi } from "./feedback";
import { adminSearchApi } from "./search";

export type { AdminUser, UserTenantRole } from "./users";
export type { CommunicationLogEntry } from "./communications";
export type { FeedbackEntry } from "./feedback";
export type { SearchRebuildStats } from "./search";

export const adminApi = {
	...adminUsersApi,
	...adminProsApi,
	...adminProjectsApi,
	...adminTaxonomyApi,
	...adminBlogsApi,
	...adminAnalyticsApi,
	...adminCommunicationsApi,
	...adminFeedbackApi,
	...adminSearchApi,
};
